// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { 
//   FaFacebookF, 
//   FaInstagram, 
//   FaLinkedinIn, 
//   FaTwitter, 
//   FaPhone, 
//   FaEnvelope, 
//   FaMapMarkerAlt,
//   FaClock,
//   FaBuilding,
//   FaArrowRight,
//   FaCcVisa,
//   FaCcMastercard,
//   FaCcAmex,
//   FaLock
// } from 'react-icons/fa';

// const Footer = () => {
//   const [imageError, setImageError] = useState(false);
//   const currentYear = new Date().getFullYear();

//   // Your background image URL
//   const backgroundImage = "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772515834/site-footer-bg-shape_sdvmsl.png";

//   const apartmentTypes = [
//     { name: "Studio Apartment",  },
//     { name: "1 Bed Apartment Faisal Mosque",  },
//     { name: "2 Bed Study Apartment",  },
//     { name: "2 Bed Apartment Faisal Mosque", },
//   ];

//   const quickLinks = [
//     { name: "Home", path: "/" },
//     { name: "Our Apartments", path: "/apartments" },
//     { name: "About Us", path: "/aboutus" },
//     { name: "Contact Us", path: "/contact" },
//     { name: "Privacy Policy", path: "/privacy-policy" },
//     { name: "Terms & Conditions", path: "/terms-and-conditions" },
//   ];

//   const contactInfo = [
//     { 
//       icon: FaMapMarkerAlt, 
//       content: "Centaurus Complex, Jinnah Avenue, Blue Area, Islamabad",
//       link: "https://maps.google.com/?q=Centaurus+Islamabad"
//     },
//     { 
//       icon: FaPhone, 
//       content: ["+92 51 2345678", "+92 51 2345679"],
//       link: "tel:+92512345678"
//     },
//     { 
//       icon: FaEnvelope, 
//       content: ["reservations@stayin.com", "info@stayin.com"],
//       link: "mailto:reservations@stayin.com"
//     },
//     { 
//       icon: FaClock, 
//       content: ["24/7 Reception", "Check-in: 2PM | Check-out: 12PM"]
//     },
//   ];

//   return (
//     <footer className="bg-[#000000f5] text-white relative overflow-hidden"
//     >
//       {/* Background Image with Overlay */}
//       <div 
//         className="absolute inset-0 z-0 opacity-20 md:opacity-30"
//          style={{
//           backgroundImage: !imageError ? `url('${backgroundImage}')` : 'none',
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           backgroundRepeat: 'no-repeat',
//           backgroundAttachment: 'fixed',
//           backgroundBlendMode:"luminosity",
//           backgroundColor:"#000000f5",
//           opacity:.03
//         }}
//         onError={() => setImageError(true)}
//       >
//         {/* Fallback pattern if image fails */}
//         {imageError && (
//           <div className="absolute inset-0 bg-gradient-to-br from-[#c9a86c]/10 to-transparent">
//             <div className="absolute inset-0" style={{
//               backgroundImage: `radial-gradient(circle at 20% 30%, rgba(201, 168, 108, 0.1) 0%, transparent 50%)`,
//             }}></div>
//           </div>
//         )}
//       </div>

//       {/* Additional decorative shapes */}
//       <div className="absolute inset-0 z-0 opacity-10">
//         <div className="absolute top-0 right-0 w-96 h-96 bg-[#c9a86c] rounded-full blur-3xl"></div>
//         <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#c9a86c] rounded-full blur-3xl"></div>
//       </div>

//       {/* Decorative Top Border */}
//       {/* <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#c9a86c] via-[#e5c9a7] to-[#c9a86c] z-10"></div> */}
      
//       {/* Main Footer */}
//       <div className="py-12 relative z-10">
//         <div className="container-custom relative">
         

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
            
//             {/* Company Info */}
//             <div className="space-y-5">
//               <div className="flex flex-col">
//                 <img src="https://res.cloudinary.com/dgwnm39m7/image/upload/v1773301516/WhatsApp_Image_2026-03-10_at_3.14.14_PM__2_-removebg-preview__1_-removebg-preview_hgjnpd.png" alt="StayIN Logo" className="w-24 h-auto transition-transform group-hover:scale-105" />
//                 <span className="text-[10px] tracking-[0.3em] text-[#c9a86c] uppercase mt-2 font-light">
//                    Centaurus Hotel Service Appartments
//                 </span>
//               </div>
              
//               <p className="text-gray-400 text-sm leading-relaxed">
//                 Experience luxury living in the heart of Islamabad. 
//                 Premium service apartments at Centaurus Complex with 
//                 breathtaking city views and world-class amenities.
//               </p>
              
//               {/* Trust Badges */}
//               <div className="flex items-center gap-3 text-gray-400">
//                 <FaLock className="text-[#c9a86c]" />
//                 <span className="text-xs">Secure Booking · SSL Encrypted</span>
//               </div>
//             </div>

//             {/* Quick Links */}
//             <div>
//               <h3 className="text-lg font-display font-semibold mb-6 relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-12 after:h-0.5 after:bg-[#c9a86c]">
//                 Quick Links
//               </h3>
//               <ul className="space-y-3">
//                 {quickLinks.slice(0, 6).map((link) => (
//                   <li key={link.name}>
//                     <Link 
//                       to={link.path}
//                       className="text-gray-400 hover:text-[#c9a86c] transition text-sm inline-flex items-center gap-2 group"
//                     >
//                       {/* <FaArrowRight className="text-[10px] opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition" /> */}
//                       <span className="group-hover:translate-x-1 transition">{link.name}</span>
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Apartment Types */}
//             <div>
//               <h3 className="text-lg font-display font-semibold mb-6 relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-12 after:h-0.5 after:bg-[#c9a86c]">
//                 Our Apartments
//               </h3>
//               <ul className="space-y-4">
//                 {apartmentTypes.map((apt) => (
//                   <li key={apt.name}>
//                     <div 
//                       className="block group"
//                     >
//                       <span className="text-gray-400 group-hover:text-[#c9a86c] transition text-sm font-medium">
//                         {apt.name}
//                       </span>
//                       {/* <span className="text-xs text-gray-500 block mt-1">
//                         {apt.desc}
//                       </span> */}
//                     </div>
//                   </li>
//                 ))}
//               </ul>

//               <Link 
//                 to="/apartments"
//                 className="inline-flex items-center gap-2 text-[#c9a86c] text-sm mt-4 hover:gap-3 transition"
//               >
//                 View All Apartments <FaArrowRight size={12} />
//               </Link>
//             </div>

//             {/* Contact Info */}
//             <div>
//               <h3 className="text-lg font-display font-semibold mb-6 relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-12 after:h-0.5 after:bg-[#c9a86c]">
//                 Contact Us
//               </h3>
//               <ul className="space-y-4">
//                 <li className="flex gap-3 text-gray-400 text-sm group">
//                   <FaMapMarkerAlt className="text-[#c9a86c] mt-1 flex-shrink-0 group-hover:scale-110 transition" />
//                   <a 
//                     href="https://maps.google.com/?q=Centaurus+Islamabad"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="hover:text-[#c9a86c] transition"
//                   >
//                     Centaurus Complex, Jinnah Avenue,<br />Blue Area, Islamabad
//                   </a>
//                 </li>
//                 <li className="flex gap-3 text-gray-400 text-sm">
//                   <FaPhone className="text-[#c9a86c] mt-1 flex-shrink-0" />
//                   <div className="flex flex-col">
//                     <a  className="hover:text-[#c9a86c] transition">92 303 4935404 </a>
//                   </div>
//                 </li>
//                 <li className="flex gap-3 text-gray-400 text-sm">
//                   <FaEnvelope className="text-[#c9a86c] mt-1 flex-shrink-0" />
//                   <div className="flex flex-col">
//                     <a href="mailto:reservations@stayin.com" className="hover:text-[#c9a86c] transition">reservations@stayin.com</a>
//                     <a href="mailto:info@stayin.com" className="hover:text-[#c9a86c] transition">info@stayin.com</a>
//                   </div>
//                 </li>
//                 <li className="flex gap-3 text-gray-400 text-sm">
//                   <FaClock className="text-[#c9a86c] mt-1 flex-shrink-0" />
//                   <div className="flex flex-col">
//                     <span>24/7 Reception</span>
//                     <span className="text-xs text-gray-500">Check-in: 2PM | Check-out: 12PM</span>
//                   </div>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Footer */}
//       <div className="border-t border-white/10 py-6 relative z-10">
//         <div className="container-custom">
//           <div className="flex flex-col md:flex-row justify-between items-center gap-4">
//             <p className="text-gray-400 text-sm text-center md:text-left">
//               &copy; {currentYear} <span className="text-[#c9a86c]">StayIN</span> Centaurus Service Apartments. 
//               All rights reserved.
//             </p>
            
//             <div className="flex items-center gap-6">
//               {/* Social Links */}
//               <div className="flex gap-3">
//                 {[FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter].map((Icon, index) => (
//                   <a 
//                     key={index}
//                     href="#" 
//                     className="bg-white/10 w-10 h-10 rounded-full flex items-center justify-center text-gray-400 hover:bg-[#c9a86c] hover:text-white transition-all hover:-translate-y-1"
//                     aria-label={`Social link ${index + 1}`}
//                   >
//                     <Icon size={16} />
//                   </a>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* Additional Links */}
//           <div className="flex flex-wrap justify-center gap-4 mt-4 text-xs text-gray-500">
//             <Link to="/terms-and-conditions" className="hover:text-[#c9a86c] transition">Terms of Service</Link>
//             <span>•</span>
//             <Link to="/privacy-policy" className="hover:text-[#c9a86c] transition">Privacy Policy</Link>
//             {/* <span>•</span>
//             <Link to="/cookies" className="hover:text-[#c9a86c] transition">Cookie Policy</Link> */}
//             {/* <span>•</span>
//             <Link to="/sitemap" className="hover:text-[#c9a86c] transition">Sitemap</Link> */}
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { 
  FaFacebookF, 
  FaInstagram, 
  FaLinkedinIn, 
  FaTwitter, 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt,
  FaClock,
  FaBuilding,
  FaArrowRight,
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaLock,
  FaTiktok 
} from 'react-icons/fa';

const Footer = () => {
  const [imageError, setImageError] = useState(false);
  const currentYear = new Date().getFullYear();

  // Your background image URL
  const backgroundImage = "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772515834/site-footer-bg-shape_sdvmsl.png";

  const apartmentTypes = [
    { name: "Studio Apartment" },
    { name: "1 Bed Apartment Faisal Mosque" },
    { name: "2 Bed Study Apartment" },
    { name: "2 Bed Apartment Faisal Mosque" },
  ];

  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "Our Apartments", path: "/apartments" },
    { name: "About Us", path: "/about-us" },
    { name: "Contact Us", path: "/contact" },
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Terms & Conditions", path: "/terms-and-conditions" },
  ];

  const contactInfo = [
    { 
      icon: FaMapMarkerAlt, 
      content: "Centaurus Complex, Jinnah Avenue, Blue Area, Islamabad",
      link: "https://maps.google.com/?q=Centaurus+Islamabad"
    },
    { 
      icon: FaPhone, 
      content: ["+92303 4935404 "],
      link: "tel:+92303 4935404 "
    },
    { 
      icon: FaEnvelope, 
      content: ["reservations@stayin.com", "info@stayin.com"],
      link: "mailto:reservations@stayin.com"
    },
    { 
      icon: FaClock, 
      content: ["24/7 Reception", "Check-in: 2PM | Check-out: 12PM"]
    },
  ];

  return (
    <>
      {/* SEO Meta Tags for Footer (Organization Schema) */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "StayIN Centaurus Serviced Apartments",
            "url": "https://stayinhospitality.com/",
            "logo": "https://res.cloudinary.com/dgwnm39m7/image/upload/v1773301516/WhatsApp_Image_2026-03-10_at_3.14.14_PM__2_-removebg-preview__1_-removebg-preview_hgjnpd.png",
            "description": "Luxury serviced apartments in Centaurus Islamabad offering premium accommodations with Faisal Mosque views and 5-star amenities.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Centaurus Complex, Jinnah Avenue, Blue Area",
              "addressLocality": "Islamabad",
              "addressCountry": "PK"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+923034935404",
              "contactType": "customer service",
              "availableLanguage": ["English", "Urdu"]
            },
            "sameAs": [
              "https://www.facebook.com/stayin",
              "https://www.instagram.com/stayin",
              "https://www.linkedin.com/company/stayin",
              "https://twitter.com/stayin"
            ]
          })}
        </script>
      </Helmet>

      <footer 
        className="bg-[#000000f5] text-white relative overflow-hidden"
        aria-label="StayIN Centaurus Serviced Apartments Footer"
        id="footer"
      >
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 z-0 opacity-20 md:opacity-30"
          style={{
            backgroundImage: !imageError ? `url('${backgroundImage}')` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            backgroundBlendMode: "luminosity",
            backgroundColor: "#000000f5",
            opacity: .03
          }}
          onError={() => setImageError(true)}
        >
          {/* Fallback pattern if image fails */}
          {imageError && (
            <div className="absolute inset-0 bg-gradient-to-br from-[#c9a86c]/10 to-transparent">
              <div className="absolute inset-0" style={{
                backgroundImage: `radial-gradient(circle at 20% 30%, rgba(201, 168, 108, 0.1) 0%, transparent 50%)`,
              }}></div>
            </div>
          )}
        </div>

        {/* Additional decorative shapes */}
        <div className="absolute inset-0 z-0 opacity-10" aria-hidden="true">
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#c9a86c] rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#c9a86c] rounded-full blur-3xl"></div>
        </div>

        {/* Main Footer */}
        <div className="py-12 relative z-10">
          <div className="container-custom relative">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
              
              {/* Company Info */}
              <div className="space-y-5">
                <div className="flex flex-col">
                  <img 
                    src="https://res.cloudinary.com/dgwnm39m7/image/upload/v1773301516/WhatsApp_Image_2026-03-10_at_3.14.14_PM__2_-removebg-preview__1_-removebg-preview_hgjnpd.png" 
                    alt="StayIN Centaurus - Luxury Serviced Apartments Islamabad Logo" 
                    className="w-24 h-auto transition-transform group-hover:scale-105" 
                  />
                  <span className="text-[10px] tracking-[0.3em] text-[#c9a86c] uppercase mt-2 font-light">
                    Centaurus Hotel Service Apartments
                  </span>
                </div>
                
                <p className="text-gray-400 text-sm leading-relaxed">
                  Experience luxury living in the heart of Islamabad. 
                  Premium service apartments at Centaurus Complex with 
                  breathtaking city views and world-class amenities.
                </p>
                
                {/* Trust Badges */}
                <div className="flex items-center gap-3 text-gray-400">
                  <FaLock className="text-[#c9a86c]" aria-hidden="true" />
                  <span className="text-xs">Secure Booking · SSL Encrypted</span>
                </div>
              </div>

              {/* Quick Links */}
              <div>
                <h3 className="text-lg font-display font-semibold mb-6 relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-12 after:h-0.5 after:bg-[#c9a86c]">
                  Quick Links
                </h3>
                <ul className="space-y-3">
                  {quickLinks.slice(0, 6).map((link) => (
                    <li key={link.name}>
                      <Link 
                        to={link.path}
                        className="text-gray-400 hover:text-[#c9a86c] transition text-sm inline-flex items-center gap-2 group"
                      >
                        <span className="group-hover:translate-x-1 transition">{link.name}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Apartment Types */}
              <div>
                <h3 className="text-lg font-display font-semibold mb-6 relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-12 after:h-0.5 after:bg-[#c9a86c]">
                  Our Apartments
                </h3>
                <ul className="space-y-4">
                  {apartmentTypes.map((apt) => (
                    <li key={apt.name}>
                      <div className="block group">
                        <span className="text-gray-400 group-hover:text-[#c9a86c] transition text-sm font-medium">
                          {apt.name}
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>

                <Link 
                  to="/apartments"
                  className="inline-flex items-center gap-2 text-[#c9a86c] text-sm mt-4 hover:gap-3 transition"
                  aria-label="View all luxury apartments in Centaurus Islamabad"
                >
                  View All Apartments <FaArrowRight size={12} aria-hidden="true" />
                </Link>
              </div>

              {/* Contact Info */}
              <div>
                <h3 className="text-lg font-display font-semibold mb-6 relative pb-3 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-12 after:h-0.5 after:bg-[#c9a86c]">
                  Contact Us
                </h3>
                <ul className="space-y-4">
                  <li className="flex gap-3 text-gray-400 text-sm group">
                    <FaMapMarkerAlt className="text-[#c9a86c] mt-1 flex-shrink-0 group-hover:scale-110 transition" aria-hidden="true" />
                    <a 
                      href="https://maps.google.com/?q=Centaurus+Islamabad"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-[#c9a86c] transition"
                      aria-label="View Centaurus Complex location on Google Maps"
                    >
                      Centaurus Complex, Jinnah Avenue,<br />Blue Area, Islamabad
                    </a>
                  </li>
                  <li className="flex gap-3 text-gray-400 text-sm">
                    <FaPhone className="text-[#c9a86c] mt-1 flex-shrink-0" aria-hidden="true" />
                    <div className="flex flex-col">
                      <a 
                        href="tel:+923034935404" 
                        className="hover:text-[#c9a86c] transition"
                        aria-label="Call StayIN Centaurus at +92 303 4935404"
                      >
                        +92 303 4935404
                      </a>
                    </div>
                  </li>
                  <li className="flex gap-3 text-gray-400 text-sm">
                    <FaEnvelope className="text-[#c9a86c] mt-1 flex-shrink-0" aria-hidden="true" />
                    <div className="flex flex-col">
                      <a 
                        href="mailto:info@stayinhospitality.com" 
                        className="hover:text-[#c9a86c] transition"
                        aria-label="Email StayIN reservations"
                      >
                        info@stayinhospitality.com
                      </a>
                    
                    </div>
                  </li>
                  <li className="flex gap-3 text-gray-400 text-sm">
                    <FaClock className="text-[#c9a86c] mt-1 flex-shrink-0" aria-hidden="true" />
                    <div className="flex flex-col">
                      <span>24/7 Reception</span>
                      <span className="text-xs text-gray-500">Check-in: 2PM | Check-out: 12PM</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-white/10 py-6 relative z-10">
          <div className="container-custom">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-gray-400 text-sm text-center md:text-left">
                &copy; {currentYear} <span className="text-[#c9a86c]">StayIN</span> Centaurus Service Apartments. 
                All rights reserved.
              </p>
              
              <div className="flex items-center gap-6">
                {/* Social Links */}
                <div className="flex gap-3">
                  {[
                    { Icon: FaFacebookF, url: "https://www.facebook.com/share/17mw5sBHYq/", label: "Facebook" },
                    { Icon: FaInstagram, url: "https://www.instagram.com/stayin_4?utm_source=qr&igsh=cWpibXdkbW9iYnFl", label: "Instagram" },
                    // { Icon: FaLinkedinIn, url: "https://www.linkedin.com/company/stayin", label: "LinkedIn" },
                    { Icon: FaTiktok, url: "https://www.tiktok.com/@stayin_1?_r=1&_t=ZS-95D8b3SdqOC", label: "TikTok" }
                  ].map((social, index) => (
                    <a 
                      key={index}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-white/10 w-10 h-10 rounded-full flex items-center justify-center text-gray-400 hover:bg-[#c9a86c] hover:text-white transition-all hover:-translate-y-1"
                      aria-label={`Follow StayIN on ${social.label}`}
                    >
                      <social.Icon size={16} aria-hidden="true" />
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Additional Links */}
            <div className="flex flex-wrap justify-center gap-4 mt-4 text-xs text-gray-500">
              <Link to="/terms-and-conditions" className="hover:text-[#c9a86c] transition">Terms of Service</Link>
              <span aria-hidden="true">•</span>
              <Link to="/privacy-policy" className="hover:text-[#c9a86c] transition">Privacy Policy</Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;